import React from 'react';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    toolbarContainer: {
        flexGrow: 1,
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex'
    }
}))

export default ({children}) => {
    const classes = useStyles();
    return <div className={classes.toolbarContainer}>
        {children}
    </div>
}